import { Component, input, TemplateRef, ChangeDetectionStrategy } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { IdGeneratorPipe } from '../../../pipes/id-generator.pipe';

@Component({
    selector: 'lib-tab-item',
    templateUrl: './tab-item.component.html',
    styleUrls: ['./tab-item.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [IdGeneratorPipe]
})
export class TabItemComponent {
    readonly tabName = input('default', {
        transform: (value: string | undefined) => value ?? 'default'
    });
    readonly icon = input<SafeHtml>();
    readonly headerTemplate = input<TemplateRef<unknown>>();
    readonly bodyTemplate = input.required<TemplateRef<unknown>>();
    readonly disabled = input(false);
    readonly tabItemId = input<string>();
}
